import queryString from 'query-string';

const routes = {
    catalogue: '/catalog',
    companySettings: '/company-settings',
    homepage: "/",
    conversations: '/conversation/:advert?/:customer?/:profile?',
    statistics: '/stats',
    login: "/login",
    registration: "/registration",
    settings: '/settings',
    forgottenPassword: '/forgotten-password',
    prerecordedMessages: '/prerecorded-messages',
};

export { routes };

export function generateUrl(route, params, query, hash) {
    for(let param in params) {
        if(params[param]) {
            let regexp = new RegExp(":" + param + '\\??');
            route = route.replace(regexp, params[param]);
        }
    }

    route = route.replace(/\/:[^/]+\?/g, '');

    if (typeof query !== "undefined") {
        route += '?' + queryString.stringify(query);
    }

    if (typeof hash !== "undefined") {
        route += "#" + hash;
    }

    return route;
}



// WEBPACK FOOTER //
// ./src/helpers/routes.js